import { Injectable } from '@angular/core';
import { SlokaDataService } from '../data/sloka.service';
import { Observable, combineLatest, of, Subject } from 'rxjs';
import {
  SlokaBackendModel,
  AddSlokaModel,
  UpdateSlokaModel,
} from '../interfaces/interfaces';
import { map, switchMap, mergeAll, first, take, flatMap } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SlokaLogicService {
  constructor(private slokaDataService: SlokaDataService) {}

  getAllSlokasLogic(): Observable<SlokaBackendModel[]> {
    return this.slokaDataService.getAllSlokasData();
  }

  uploadAudioFileLogic(file: any, key: string) {
    return this.slokaDataService.uploadAudioFileData(file, key);
  }

  uploadPdfFileLogic(file: any, key: string) {
    return this.slokaDataService.uploadPdfFileData(file, key);
  }

  addSlokaLogic(
    title: string,
    slokaTypeId: string,
    synopsis: string,
    videoLink: string,
    audioFile: any,
    pdfFile: any,
    english: string,
    sanskrit: string,
    both: string
  ) {
    return combineLatest([
      this.uploadAudioFileLogic(
        audioFile,
        moment().valueOf() + '-' + 'sloka-audio.mp3'
      ),
      this.uploadPdfFileLogic(pdfFile, moment().valueOf() + '-' + 'sloka-pdf.pdf'),
    ]).pipe(
      map((r) => {
        let audioUrl = r[0];
        let pdfUrl = r[1];

        //if (audioUrl == 'error' || pdfUrl == 'error') return;

        // console.log('file came 2 ', audioUrl, pdfUrl);

        let addSlokaModel = new AddSlokaModel(
          title,
          slokaTypeId,
          synopsis,
          english,
          sanskrit,
          both,
          videoLink,
          audioUrl,
          pdfUrl
        );

        return this.slokaDataService.addSlokaData(addSlokaModel);
      }),
      mergeAll()
    );
  }

  updateSlokaLogic(
    title: string,
    slokaTypeId: string,
    synopsis: string,
    videoLink: string,
    audioFile: any,
    audioLink: any,
    pdfFile: any,
    pdfLink: any,
    english: string,
    sanskrit: string,
    both: string,
    id: string
  ): Observable<{}> {

    let audio: string = "";
    let pdf: string = "";

    if(pdfLink != "error" || pdfLink != null || pdfLink != ""){

      pdf = moment().valueOf() + '-' + 'sloka-pdf.pdf';

    } else {

      pdf = pdfLink.split('/')[3];

    };


    if(audioLink != "error" || audioLink != null || audioLink != ""){

      audio = moment().valueOf() + '-' + 'sloka-audio.mp3';

    } else {

      audio = audioLink.split('/')[3];

    }

    return combineLatest([
      audioFile != null
        ? this.uploadAudioFileLogic(audioFile, audio)
        : of(audioLink),
      pdfFile != null
        ? this.uploadPdfFileLogic(pdfFile, pdf)
        : of(pdfLink),
    ]).pipe(
      map((l) => {
        let finalAudioLink = l[0];
        let finalPdfLink = l[1];
        let updateSlokaModel = new UpdateSlokaModel(
          title,
          slokaTypeId,
          synopsis,
          english,
          sanskrit,
          both,
          videoLink,
          finalAudioLink,
          finalPdfLink,
          id
        );

        return this.slokaDataService.updateSlokaData(updateSlokaModel);
      }),
      mergeAll()
    );
  }

  deleteSlokaLogic(slokaId: string) {
    return this.slokaDataService.deleteSlokaData(slokaId);
  }
}
